/*
 * Public API Surface of phone-number
 */

export const abc = 'abc';
